import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface CatalogueRow {
  readonly apiId: string;
  readonly apiCode: string;
  readonly apiName: string;
  readonly apiType: string;
  readonly version: string;
}

export function M20DeveloperPortalPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<CatalogueRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: CatalogueRow[] }>('/v1/integration/developer-portal/catalogue', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m20.developerPortal.loading')}</p>;
  return (
    <main aria-label="developer-portal">
      <h1>{t('m20.developerPortal.title')}</h1>
      <table aria-label="developer-portal-table">
        <thead><tr><th>{t('m20.developerPortal.colCode')}</th><th>{t('m20.developerPortal.colName')}</th><th>{t('m20.developerPortal.colType')}</th><th>{t('m20.developerPortal.colVersion')}</th></tr></thead>
        <tbody>
          {rows.map((a) => (
            <tr key={a.apiId}>
              <td>{a.apiCode}</td>
              <td>{a.apiName}</td>
              <td>{a.apiType}</td>
              <td>{a.version}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
